var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.653 11.977c0 .431-.185.801-.495 1.048l-6.936 6.101c-.496.432-1.239.37-1.61-.123-.372-.493-.372-1.17.123-1.602l6.07-5.3c.061-.062.061-.124 0-.247l-6.07-5.3a1.097 1.097 0 01-.062-1.603 1.232 1.232 0 011.61-.123l6.937 6.04c.248.308.433.678.433 1.11z"
  })));
}
export default SvgIconRight24;